'use client';

import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { CountrySelector } from '@/react/components/country/CountrySelector';
import { LanguageSelector } from '@/react/components/country/LanguageSelector';

import S from './styles.base.module.scss';

/**
 * CountryAndLanguageSelector component.
 *
 * Wrapper that renders both the CountrySelector and LanguageSelector components.
 */
export const CountryAndLanguageSelector: FC = observer(
  function CountryAndLanguageSelector() {
    return (
      <div className={S.container}>
        <CountrySelector />
        <LanguageSelector />
      </div>
    );
  }
);
